import React from "react";
import { useAuth } from "../../hooks/useAuth";

const DevBypass: React.FC = () => {
  const { isDevBypass, toggleDevBypass } = useAuth();
  const isDevelopment = import.meta.env.DEV;

  // Check if we're on allowed domains
  const currentHostname = window.location.hostname;
  const allowedDevDomains = [
    "dev.gesslargardens.com",
    "stage.gesslargardens.com",
  ];
  const isAllowedDomain = allowedDevDomains.includes(currentHostname);
  const isCloudFrontDomain = currentHostname.endsWith("cloudfront.net");

  // Show component in development mode OR on allowed domains OR on CloudFront domains
  const shouldShowDevBypass =
    isDevelopment || isAllowedDomain || isCloudFrontDomain;

  if (!shouldShowDevBypass) return null;

  // Determine the environment label
  let envLabel = "DEV";
  if (isAllowedDomain) {
    envLabel = currentHostname.startsWith("dev.") ? "DEV" : "STAGE";
  } else if (isCloudFrontDomain) {
    envLabel = "CLOUD";
  }

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        left: "20px",
        zIndex: 1000,
        backgroundColor: isDevBypass ? "#fd3d3d" : "#6c757d",
        color: "white",
        padding: "8px 12px",
        borderRadius: "4px",
        boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        fontFamily: "sans-serif",
        fontSize: "14px",
      }}
      onClick={toggleDevBypass}
      title="Toggle authentication bypass for development/staging"
    >
      <span style={{ marginRight: "8px" }}>{isDevBypass ? "🔓" : "🔒"}</span>
      <span>
        {isDevBypass
          ? `${envLabel} MODE: Auth Bypassed`
          : `${envLabel} MODE: Auth Required`}
      </span>
    </div>
  );
};

export default DevBypass;
